export const WALLET_TRANSACTIONS_PAGE_SIZE_OPTIONS = [7, 10, 15, 20] as const

export type WalletTransactionsPageSize =
  (typeof WALLET_TRANSACTIONS_PAGE_SIZE_OPTIONS)[number]

export const DEFAULT_WALLET_TRANSACTIONS_PAGE_SIZE: WalletTransactionsPageSize = 7
